import { render, staticRenderFns } from "./TrafficHourForm.vue?vue&type=template&id=15741302&"
import script from "./TrafficHourForm.vue?vue&type=script&lang=js&"
export * from "./TrafficHourForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports